export const signedOutView = {
  'signed-out-view.welcome': 'Welcome to the sweet life',
  'signed-out-view.sign-in': 'Sign in',
  'signed-out-view.not-joined': "Don't have an account?",
  'signed-out-view.join-now': 'Join now',
};
